import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, tokenStore } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(tokenStore.user);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    if (!tokenStore.access) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("whoonow_user", JSON.stringify(data));
    } catch {
      setUser(tokenStore.user);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: se stiamo tornando dal callback OAuth, salta il check /me.
    // AuthCallback scambia prima il session_id e stabilisce la sessione.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    tokenStore.save(data);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    tokenStore.save(data);
    setUser(data.user);
    return data.user;
  };

  const exchangeGoogleSession = async (sessionId) => {
    const { data } = await api.post("/auth/session", { session_id: sessionId });
    tokenStore.save(data);
    setUser(data.user);
    return data.user;
  };

  const loginWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/home";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout", { refresh_token: tokenStore.refresh });
    } catch (e) {
      console.warn("logout error", e?.response?.status);
    }
    tokenStore.clear();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, loginWithGoogle, exchangeGoogleSession, refreshUser: checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}
